"use client";

export const META_TRACK_ENDPOINT = "/api/meta/track";

export function sendMetaTrackPayload(body: string): void {
  if (typeof window === "undefined") return;

  try {
    const blob = new Blob([body], { type: "application/json" });
    if (navigator.sendBeacon) {
      const sent = navigator.sendBeacon(META_TRACK_ENDPOINT, blob);
      if (sent) return;
    }

    fetch(META_TRACK_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body,
      keepalive: true,
    }).catch(() => {});
  } catch {
    // Meta tracking must never break page interactions.
  }
}
